import React /* , { useContext } */ from 'react';
import styles from './css/AllInvoices.scss';
/* import PDFView from '../PDFView';
import getHistoryListDefaultHOCEnhance from './../../main/HistoryListDefaultHOC';
import HistoryList from '../../main/HistoryList'; */
//import red from '@mui/material/colors/red';
//import green from '@mui/material/colors/green';
/* import { store } from '../store'; */

/* const InvoiceList = getHistoryListDefaultHOCEnhance({
	store,
	method: 'GET',
	url: '/get/all/invoices',
	options: {}
})(HistoryList); */

const AllInvoices = props => {
	/* const { dispatch } = useContext(store);

	function onViewPDF(invoiceID) {
		console.log('invoiceID', invoiceID);

		dispatch({
			type: 'open dialog',
			dlgCmp: (
				<PDFView url={`/api/invoice/view/INVOICE_${invoiceID}.pdf`} />
			)
		});
	}

	function onTabChange() {} */

	return <div className={styles.wrap}></div>;
};
export default AllInvoices;
